import {
  getDynamicBlueboxTestStatuses,
  getUniqueSectionNames,
  blueboxSectionNameFormatter,
  sectionRegex,
} from '../../../../constants/blueboxTestStatus';
import { DAP_STUDENT_TEST_STATUS } from '../../../../constants/bluebox';
import { generateStatus } from '../../../common/students/utility';
import { examStatusSort } from '../../../../constants/blueboxExamStatus';

export function generateStudentsDisplayValues(students, orgEvent: { tdtkAsmtType: string }) {
  return students.map((student) => {
    const uniqueSectionNames = getUniqueSectionNames(students);
    //NOTE: Any changes to the following getDynamicBlueboxTestStatuses or blueboxSectionNameFormatter, must have unit tests run for wherever this function is imported.
    const blueboxTestStatuses = getDynamicBlueboxTestStatuses(uniqueSectionNames, orgEvent.tdtkAsmtType);
    const matchingEnum = blueboxTestStatuses?.find((stat) => stat?.name === blueboxSectionNameFormatter(student));

    let displayName = '';
    if (
      matchingEnum?.name?.startsWith(DAP_STUDENT_TEST_STATUS.SECTION_START_TIME) &&
      student?.dapTestStatus?.payload?.sectionName
    ) {
      displayName = student.dapTestStatus.payload.sectionName;
    } else {
      displayName = matchingEnum?.displayName || '';
    }

    let name = '';
    if (
      matchingEnum?.name === DAP_STUDENT_TEST_STATUS.SECTION_START_TIME &&
      student?.dapTestStatus?.payload?.sectionName?.match(sectionRegex)
    ) {
      name = `${DAP_STUDENT_TEST_STATUS.SECTION_START_TIME}-${
        student.dapTestStatus.payload.sectionName.match(sectionRegex)[0]
      }`;
    } else {
      // eslint-disable-next-line
      name = matchingEnum?.sectionName || matchingEnum?.name;
    }

    return {
      ...student,
      status: generateStatus(student),
      dapTestStatus: {
        ...student.dapTestStatus,
        displayName, // used by the RosterRow component
        // name, do not want to override name, since we use original statuses for filtering purposes
        sortOrder: matchingEnum?.sortOrder,
      },
      dapExamStatus: {
        ...student.dapExamStatus,
        sortOrder: examStatusSort(student),
      },
      accommodationsSortOrder: student.accommodationsArray.length === 0 ? 1 : 0,
    };
  });
}
